import { priceSimulationActionTypes as actionTypes } from "../ActionTypes/priceSimulationActionTypes";

const initialState = {
    packages: null,
    packageDetailsMap: {},
    packageMetadataMap: {},
    reviewers: [],
}

export default function PriceSimulationReducer(state = { ...initialState }, action) {
    let newState = { ...state };

    switch (action.type) {
        case actionTypes.STORE_PRICE_SIMULATION_PACKAGES:
            newState.packages = action.data;
            break;
        case actionTypes.STORE_PRICE_SIMULATION_PACKAGE_CONTEXT:
            newState.packageDetailsMap = {
                ...newState.packageDetailsMap,
                [action.packageId]: action.data
            };
            break;
        case actionTypes.STORE_PRICE_SIMULATION_METADATA:
            newState.packageMetadataMap = {
                ...newState.packageMetadataMap,
                [action.packageId]: {
                    hasActiveProposal: action.hasActiveProposal,
                    isOutdatedVersion: action.isOutdatedVersion,
                },
            };
            break;
        case actionTypes.SAVE_DRAFT_PROPOSALS: {
            const updatedMetadata = { ...newState.packageMetadataMap };
            (action.packages || []).forEach(pkg => {
                updatedMetadata[pkg.packageId] = {
                    ...updatedMetadata[pkg.packageId],
                    hasActiveProposal: true,
                };
            });
            newState.packageMetadataMap = updatedMetadata;
            break;
        }
        case actionTypes.INVALIDATE_PACKAGE_CONTEXTS: {
            const updated = { ...newState.packageDetailsMap };
            (action.packageIds || []).forEach(id => {
                delete updated[id];
            });
            newState.packageDetailsMap = updated;
            break;
        }
        case actionTypes.STORE_REVIEWERS:
            newState.reviewers = action.data;
            break;
        case actionTypes.SUBMIT_FOR_APPROVAL_SUCCESS: {
            newState.packageDetailsMap = {};
            newState.packageMetadataMap = {};
            break;
        }
        default:
            return state;
    }

    return newState;
}
